import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import type { FC } from 'react';

export const Plate: FC<{ rego: string; stolen: boolean }> = ({
  rego,
  stolen,
}) => (
  <Box
    sx={{
      background: stolen ? '#FF8080' : '#E0E0E0',
      borderRadius: '5px',
      p: '2px',
      width: 'fit-content',
    }}
  >
    <Box
      sx={{
        border: 'solid black 2px',
        borderRadius: '3px',
        textAlign: 'center',
        width: 80,
      }}
    >
      <Typography
        color="black"
        sx={{ fontFamily: 'Share Tech Mono', fontSize: '1rem', px: '6px' }}
        variant="body2"
      >
        {rego}
      </Typography>
    </Box>
  </Box>
);
